import { Formik } from "formik";
import React from "react";
import { useMutation } from "react-apollo";
import { Button, Form, Modal } from "react-bootstrap";
import * as yup from 'yup';
import { CREATE_GROWER } from "../../../../../queries";
import { useStore } from "../../../providers/AppProvider";

type AddGrowerModalProps = {
    isOpen: boolean,
    onClose: () => void;
}

const schema = yup.object().shape({
    name: yup.string().required(),
    description: yup.string(),
});

export const CreateGrower = ({ isOpen, onClose }:AddGrowerModalProps) => {
    const { orgId } = useStore();

    const [createGrower] = useMutation(CREATE_GROWER, {
        awaitRefetchQueries: true,
        refetchQueries: [
            'GetGrowers' // Query name
        ],
    });

    return (
        <Modal show={isOpen} onHide={onClose}>
                <Formik
                    enableReinitialize={true}
                    initialValues={{
                        name: "",
                        description: ""
                    }}
                    validationSchema={schema}
                    validateOnChange={false}
                    validateOnBlur={false}
                    onSubmit={async (values, { setSubmitting }) => {
                        setSubmitting(true);
                        await createGrower({ variables: {data:{ org_id: orgId, name: values.name, description: values.description }} } );
                        setSubmitting(false);
                        onClose();
                    }}
                >
                    {({
                        values,
                        errors,
                        handleChange,
                        handleBlur,
                        handleSubmit
                    }) => {
                        return (
                            <Form noValidate onSubmit={handleSubmit} autoComplete="off">
                                 <Modal.Header closeButton>
                                    <Modal.Title>Add a Grower</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                placeholder="Enter name"
                                                value={values.name}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={!!errors.name}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.name}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    <div>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Description</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="description"
                                                placeholder="Enter description"
                                                value={values.description}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={!!errors.description}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.description}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <div className="d-flex justify-content-between">
                                        <div className="d-flex gap-2">
                                            <Button variant="primary" type="submit">
                                                Create
                                            </Button>
                                            <Button variant="secondary" className="mx-2"  onClick={onClose}>
                                                Cancel
                                            </Button>
                                        </div>
                                    </div>
                                </Modal.Footer>
                            </Form>
                        );
                    }}
                </Formik>
        </Modal>
    );
};

